export var LOGIN_SECONDARY_TYPE;
(function (LOGIN_SECONDARY_TYPE) {
    LOGIN_SECONDARY_TYPE[LOGIN_SECONDARY_TYPE["none"] = 0] = "none";
    LOGIN_SECONDARY_TYPE[LOGIN_SECONDARY_TYPE["sso"] = 1] = "sso";
    LOGIN_SECONDARY_TYPE[LOGIN_SECONDARY_TYPE["custom"] = 2] = "custom";
})(LOGIN_SECONDARY_TYPE || (LOGIN_SECONDARY_TYPE = {}));
export var MFA_REQUEST_CODE = '__MFA_REQUEST_CODE__';
//# sourceMappingURL=types.js.map